import { Component, Vue,Prop,Watch, Emit } from "vue-property-decorator";

@Component
export default class couponModal extends Vue {
    @Prop()couponListModal:any=false
	conponType: any = {
		"1": "店铺券",
		"2": "商品券",
		"3": "运费券",
		"4": "充值券",
		"5": "通用券",
		"6": "品类券",
	};
	getCouponApi: string = "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/coupon/list" //优惠券列表api;
	setCouponHiddenApi: string = "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/coupon/hidden" //设置优惠券显示隐藏api;
    couponData:any =[]

	stop(e: any) {
		e.stopPropagation();
	}
    // 监测关闭优惠券弹窗
    @Watch('couponListModal')
    watchClose(val:any){
        if(!val){
            setTimeout(() => {
                this.$emit("closeCouponModal")
            }, 200);
        }
    }

	mounted() {
        this.getCoupon()
    }
    
	getCoupon() {//获取优惠券列表
        this.fetch({
			url: this.getCouponApi+"?room_id="+this.$route.params.id,
			method: "get",
		}).then((res: any) => {
            this.couponData = res
		});
	}
	setCouponHidden(type:any,coupon:any) {//设置优惠券显示隐藏
        this.fetch({
			url: `${this.setCouponHiddenApi}?room_id=${this.$route.params.id}&coupon=${coupon.batchId}&hidden=${type}`,
			method: "get",
		}).then((res: any) => {
            coupon.hidden = type
		});
	}
	setCoupon(coupon:any){
		coupon.isSetCouponShow = !coupon.isSetCouponShow
		this.$forceUpdate();
	}
}
